const types = {
  CHANGE_CONFIRM_STATUS: 'confirm/CHANGE_CONFIRM_STATUS',
};

export default types;
